import Vue from 'vue'
import "@/global/index"

import '@/global/index_jobfair'

// 引入个性化组件样式
import '@/common/sass/group/job-list-group.scss'

// 引入该页面个性化UI组件
import {
  Card, TabPane, Tabs, Avatar, InfiniteScroll, Divider, Row, Step, Steps, Tag, Carousel, CarouselItem
} from 'element-ui'

Vue.use(Card)
Vue.use(TabPane)
Vue.use(Tabs)
Vue.use(Avatar)
Vue.use(InfiniteScroll)
Vue.use(Divider)
Vue.use(Row)
Vue.use(Step)
Vue.use(Steps)
Vue.use(Tag)
Vue.use(Carousel)
Vue.use(CarouselItem)

import store from '@/store/global-store'
// import App from './App'
import App from './newApp'

new Vue({
  store,
  render: h => h(App),
  created: function () {

  }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/seeker/company_detail/company_detail.js